// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS ServiceType INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { has, isEmpty } from 'lodash';
import { Icon } from '@unite-us/ui';
import getIcon from "../utils/getIcon";
var _ServiceType = function ServiceType(_ref) {
  var serviceType = _ref.serviceType,
    level = _ref.level,
    showIcon = _ref.showIcon,
    iconColor = _ref.iconColor;
  var itemClass = function itemClass() {
    return classNames({
      'ui-service-type': true,
      'ui-service-type__parent': level <= 0,
      'ui-service-type__child': level > 0
    });
  };
  return /*#__PURE__*/React.createElement("li", {
    className: itemClass()
  }, /*#__PURE__*/React.createElement("div", {
    className: "ui-service-type__item"
  }, showIcon && /*#__PURE__*/React.createElement("span", {
    className: "ui-service-type__item-icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: getIcon(serviceType.code),
    color: iconColor,
    size: 18
  })), /*#__PURE__*/React.createElement("span", {
    className: "ui-service-type__item-name"
  }, serviceType.name)), has(serviceType, 'children') && !isEmpty(serviceType.children) && /*#__PURE__*/React.createElement("ul", {
    className: "ui-service-type__item-children list-unstyled"
  }, serviceType.children.map(function (st) {
    return /*#__PURE__*/React.createElement(_ServiceType, {
      key: "ui-service-type-".concat(level, "-").concat(st.code),
      serviceType: st,
      level: level + 1,
      showIcon: false,
      iconColor: iconColor
    });
  })));
};
_ServiceType.propTypes = {
  iconColor: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired,
  serviceType: PropTypes.shape({
    children: PropTypes.array,
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  showIcon: PropTypes.bool.isRequired
};
export default _ServiceType;